import { Router } from 'vue-router';
import { useI18n } from 'vue-i18n';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import type { GroupedResults, RecentBrandItem, ResultId, SearchService } from '@bc/discovery/domain/search';
import { DEFAULT_ARROW_POSITION } from '@bc/discovery/feature/search/constants';

const state = {
  country: '',
  originalUserInput: '',
  isOpen: false,
  arrowPosition: DEFAULT_ARROW_POSITION,
  shouldDisplayBrandResults: false,
  results: {
    trending: [],
    suggestions: [],
    categories: [],
    brands: [],
    searchAll: null,
    r2bLink: null,
    history: [],
    recentBrands: [],
    boutiques: [],
    collections: [],
  } as GroupedResults,
  resultsIds: [] as ResultId[],
  userLocalHistory: [],
  userLocalBrandHistory: [] as RecentBrandItem[],
};
export type SearchState = typeof state;

export const createSearchStore = (searchService: SearchService, i18n: ReturnType<typeof useI18n>, router?: Router) => {
  return {
    namespaced: true,
    state,
    getters,
    mutations: mutations(),
    actions: actions(searchService, i18n.locale.value, router),
  };
};
